import {
    MinusCircleOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Modal,
    Row,
    Upload,
    notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { getBase64 } from "../../services/util";
import TextArea from "antd/lib/input/TextArea";
import HTTP from "../../services/httpService";

function AddEditForm({ editRecord, handleCancel }) {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [title, setTitle] = useState("Add");
    const [imageUrl, setImageUrl] = useState();
    const [formData, setFormData] = useState({});

    useEffect(() => {
        editRecord && form.setFieldsValue({ ...editRecord });
        editRecord && setTitle("Edit");
        if (editRecord?.photo_url) {
            setImageUrl(editRecord.photo_url);
        }
        setOpen(true);
        return () => {
            setOpen(false);
        };
    }, []);

    const handleChange = async (info) => {
        console.log("change event called");
        getBase64(info.file, async (imageUrl) => {
            setFormData({ file_name: info.file.name, file_path: imageUrl });
            setImageUrl(imageUrl);
        });
    };

    async function handleSubmit(value) {
        delete value.user_avatar;

        let addFormData = Object.fromEntries(
            Object.entries(value).map(([key, value], cur) => {
                if (value == undefined) return [key, ""];
                return [key, value];
            }, {}),
        );

        if (Object.entries(formData).length > 0) {
            addFormData = { ...addFormData, ...formData };
            setFormData({});
        }

        const url = addFormData.id
            ? "/backOffice/editBackOfficeContact"
            : "/backOffice/addBackOfficeContact";

        if (addFormData.file_path && addFormData.file_path) {
            delete addFormData.photo_url;
        }

        const { success, message } = await HTTP(url, {
            ...addFormData,
            staff_id,
        });

        if (success) {
            setFormData({});
            handleCancel(1);
            return notification["info"]({ message });
        }
        handleCancel();
        notification["error"]({ message });
    }
    const multipleFields = (key) => (
        <Form.List name={key}>
            {(fields, { add, remove }) => {
                if (!fields.length) setTimeout(() => add(), 10);
                return (
                    <>
                        {fields.map((field, index) => (
                            <Form.Item
                                key={field.key}
                                style={{
                                    margin: 0,
                                    padding: 0,
                                    justifyContent: "end",
                                }}
                                rules={[{ required: true }]}
                            >
                                <Row>
                                    <Form.Item
                                        style={{
                                            marginBottom: 5,
                                            paddingBottom: 5,
                                        }}
                                        name={[field.name, "first_name"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter First Name..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            placeholder="First Name"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        style={{
                                            marginBottom: 5,
                                            paddingBottom: 5,
                                        }}
                                        name={[field.name, "last_name"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter Last Name..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            placeholder="Last Name"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        style={{
                                            marginBottom: 5,
                                            paddingBottom: 5,
                                        }}
                                        name={[field.name, "email"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter Email..!",
                                            },
                                            {
                                                type: "email",
                                                message:
                                                    "Please Enter Valid Email..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="email"
                                            placeholder="Email"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        style={{
                                            marginBottom: 5,
                                            paddingBottom: 5,
                                        }}
                                        name={[field.name, "number"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter Phone..!",
                                            },
                                            {
                                                pattern: /^(?:\d*)$/,
                                                message:
                                                    "Only Digits Allowed..!",
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Phone" />
                                    </Form.Item>
                                    {fields.length > 1 && (
                                        <MinusCircleOutlined
                                            style={{
                                                fontSize: "15px",
                                                color: "red",
                                            }}
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}
                                        />
                                    )}
                                </Row>
                            </Form.Item>
                        ))}
                        {fields.length < 2 && (
                            <Form.Item
                                style={{ marginBottom: "5px", padding: 0 }}
                            >
                                <PlusCircleOutlined
                                    style={{
                                        fontSize: "15px",
                                        color: "green",
                                    }}
                                    onClick={() => add()}
                                />
                            </Form.Item>
                        )}
                    </>
                );
            }}
        </Form.List>
    );

    return (
        <Modal
            open={open}
            title={title}
            onCancel={handleCancel}
            destroyOnClose
            width={"60%"}
            footer={""}
        >
            <Form form={form} name="basic" onFinish={handleSubmit}>
                <Row align={"top"}>
                    <Col span={4}>
                        <Form.Item name="user_avatar" valuePropName="file">
                            <Upload
                                beforeUpload={() => false}
                                maxCount={1}
                                name="avatar"
                                listType="picture-card"
                                showUploadList={false}
                                onChange={handleChange}
                                accept=".jpg,.png"
                            >
                                {imageUrl ? (
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        style={{ width: "100%" }}
                                    />
                                ) : (
                                    <div>
                                        <PlusOutlined />
                                        <div style={{ marginTop: 8 }}>
                                            Upload
                                        </div>
                                    </div>
                                )}
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Col span={10}>
                        <Card
                            className="box-shadow margin-right-10"
                            title="Hotel Information"
                        >
                            <Row>
                                <Form.Item
                                    label="Property Name"
                                    name="property_name"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please Enter Property Name..!",
                                        },
                                    ]}
                                >
                                    <Input id="property_name" />
                                </Form.Item>
                            </Row>
                            {/*  <Row>
                                <Form.Item
                                    label="Last Name"
                                    name="last_name"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please Enter Last Name..!",
                                        },
                                    ]}
                                >
                                    <Input id="last_name" />
                                </Form.Item>
                            </Row> */}
                            <Row>
                                <Form.Item
                                    label="Company"
                                    name="company_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Company..!",
                                        },
                                    ]}
                                >
                                    <Input id="company" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[
                                        { type: "email" },
                                        {
                                            required: true,
                                            message: "Please Enter Email..!",
                                        },
                                    ]}
                                >
                                    <Input id="email" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item label="Web Page" name="web_page">
                                    <Input id="web_page" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="Fax Number"
                                    name="fax_number"
                                    rules={[
                                        {
                                            pattern: /^(?:\d*)$/,
                                            message: "Only Digits Allowed..!",
                                        },
                                    ]}
                                >
                                    <Input id="fax_number" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="Category"
                                    name="category"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Category..!",
                                        },
                                    ]}
                                >
                                    <Input id="category" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="Street"
                                    name="street"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Street..!",
                                        },
                                    ]}
                                >
                                    <Input id="street" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="City"
                                    name="city"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter City..!",
                                        },
                                    ]}
                                >
                                    <Input id="city" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="State"
                                    name="state_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter State..!",
                                        },
                                    ]}
                                >
                                    <Input id="state_name" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="Zip"
                                    name="zip_code"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Zip..!",
                                        },
                                        {
                                            pattern: /^(?:\d*)$/,
                                            message: "Only Digits Allowed..!",
                                        },
                                    ]}
                                >
                                    <Input id="zip_code" />
                                </Form.Item>
                            </Row>
                            <Row>
                                <Form.Item
                                    label="Country"
                                    name="country"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Country..!",
                                        },
                                    ]}
                                >
                                    <Input id="country" />
                                </Form.Item>
                            </Row>
                        </Card>
                    </Col>
                    <Col span={10}>
                        <Card
                            className="box-shadow margin-left-10"
                            title="Owner"
                        >
                            <Row>
                                <Form.Item label="Phone">
                                    {multipleFields("phone_number")}
                                </Form.Item>
                            </Row>
                        </Card>
                        <Card
                            className="box-shadow margin-left-10 margin-top-10"
                            title="Operation Contact"
                        >
                            <Row>
                                <Form.Item label="Bussiness Phone">
                                    {multipleFields("business_phone_number")}
                                </Form.Item>
                            </Row>
                        </Card>
                        <Card
                            className="box-shadow margin-left-10 margin-top-10"
                            title="Account's Contact"
                        >
                            <Row>
                                <Form.Item label="Account Phone">
                                    {multipleFields("account_phone_number")}
                                </Form.Item>
                            </Row>
                        </Card>
                        <Card
                            className="box-shadow margin-left-10 margin-top-10"
                            title="Hotel Contact"
                        >
                            <Row>
                                <Form.Item label="Mobile Phone">
                                    {multipleFields("mobile_number")}
                                </Form.Item>
                            </Row>
                        </Card>
                        <Row>
                            <Form.Item name="notes" label="Notes">
                                <TextArea rows={3} />
                            </Form.Item>
                            <Form.Item name="id" hidden>
                                <Input />
                            </Form.Item>
                            <Form.Item name="photo_url" hidden>
                                <Input />
                            </Form.Item>
                        </Row>
                    </Col>
                </Row>

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default AddEditForm;
